export const DAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const DEFAULT_OPEN_TIME = '08:00';
export const DEFAULT_CLOSE_TIME = '20:00';

// storeAssistSettings stores times as an ISO placeholder date where only HH:MM matter.
export const isoToHHMM = (iso: string): string => {
  const match = /T(\d{2}):(\d{2})/.exec(iso ?? '');
  return match ? `${match[1]}:${match[2]}` : '';
};

export const hhmmToIso = (hhmm: string): string => {
  const [hours = '00', minutes = '00'] = hhmm.split(':');
  return `1970-01-01T${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:00.000Z`;
};
